module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Revelation")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FMTitle"
  }, [_c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_vm._v("Abbreviations")])]), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_c('table', {
    staticClass: "Table1",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("ACCS")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Ancient Commentary of Christian Scripture")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("ATR")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Anglican Theological Review")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("BAGD")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Walter Bauer, William F. Arndt, F. William Gingrich, and Frederick W. Danker, "), _c('i', [_vm._v("A Greek-English Lexicon of the New Testament and Other Early Christian Literature")]), _vm._v(" (Chicago: University of Chicago Press, 2nd edition, 1958)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("BCOT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Baker Commentary on the Old Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("BZNW")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("CBQ")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Catholic Biblical Quarterly")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("CNT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Commentaire du Nouveau Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("CTJ")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Calvin Theological Journal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("CTM")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Calwer theologische Monographien")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("ECNT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Exegetical Commentary of the New Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("EDNT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Horst Balz and Gerhard Schneider, eds., "), _c('i', [_vm._v("Exegetical Dictionary of the New Testament")]), _vm._v(" (3 vols. Grand Rapids: Eerdmans, 1990-1993).")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("EQ")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Evangelical Quarterly")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("EUSST")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("European University Studies")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("HTR")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Harvard Theological Review")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("ICC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("International Critical Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("Int")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Interpretation")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JBL")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Journal of Biblical Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JETS")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Journal of the Evangelical Theological Society")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("JPTS")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Journal of Pentecostal Theology Supplement")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JSNT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Journal for the Study of the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("JSNTS")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Journal for the Study of the New Testament Supplement")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JTS")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Joournal of Theological Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("MBPS")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Mellen Biblical Press Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }, [_vm._v("NCCS")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New Covenant Commentary Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NDT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Das Neue Testament deutsch")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NIBC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New International Bible Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NICNT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New International Commentary on the New Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("NIDNTT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Colin Brown, ed., "), _c('i', [_vm._v("New International Dictionary of New Testament Theology")]), _vm._v(" (3 vols. Grand Rapids: Zondervan, 1975-78)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NIGNT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New International Greek New Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("NovT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Novum Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("NRT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("La nouvelle revue théologique")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NTM")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New Testament Message")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("NTS")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("New Testament Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("PTMS")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Pittsburgh Theological Monograph Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("PTR")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Princeton Theological Review")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("SBL")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Society of Biblical Literature")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("SNTSMS")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Society for New Testament Studies Monograph Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("TDNT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Gerhard Kittel and Gerhard Friedrich, eds., "), _c('i', [_vm._v("Theological Dictionary of the New Testament")]), _vm._v(" (trans. Geoffrey W. Bromiley; 10 vols; Grand Rapids: Eerdmans, 1964-)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("TynB")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Tyndale Bulletin")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("WBC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Word Biblical Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("WUNT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Wissenschaftliche Untersuchungen zum Neuen Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("ZNW")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283c293a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 75
// module chunks = 0